const ABProcessTaskServiceAccountingBatchProcessingCore = require("../../../core/process/tasks/ABProcessTaskServiceAccountingBatchProcessingCore");
module.exports = class ABProcessTaskServiceAccountingBatchProcessing extends (
   ABProcessTaskServiceAccountingBatchProcessingCore
) {};
